import React from 'react';

export interface TableColumn {
  uid: string;
  name: string;
  sortable?: boolean;
  align?: 'start' | 'center' | 'end' | string;
  cellClass?: string;
}

export function useVisibleColumns(
  columns: TableColumn[],
  initialVisible?: string[]
) {
  const [visibleColumns, setVisibleColumns] = React.useState<Set<string>>(
    () => new Set(initialVisible || columns.map((c) => c.uid))
  );

  const headerColumns = React.useMemo(() => {
    if ((visibleColumns as unknown as string) === 'all') return columns;

    return columns.filter((c) => Array.from(visibleColumns).includes(c.uid));
  }, [columns, visibleColumns]);

  return {
    visibleColumns,
    setVisibleColumns,
    headerColumns
  };
}
